import angular from 'angular';
import scenes from './scenes';
import components from './components';
import MergeService from './services/mergeService';

export default angular
  .module('scenes.mergeContact', [components, scenes])
  .service('mergeService', MergeService).name;
